import { render, staticRenderFns } from "./couponCreate.vue?vue&type=template&id=2dc6da5f&"
import script from "./couponCreate.vue?vue&type=script&lang=js&"
export * from "./couponCreate.vue?vue&type=script&lang=js&"
import style0 from "./couponCreate.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports